import { getPersonalizationCampaigns } from "../services/personalization.service";
import { handleize } from "../helpers/utils";
class MainNavDesktop extends HTMLElement {
    constructor() {
        super();
        this.config = null;
        this.categoryEl = null;
        this.addEventListener("focusin", this.handleNavChange);
        this.addEventListener("mouseover", this.handleNavChange);
    }
    async connectedCallback() {
        var _a, _b, _c, _d;
        console.log("MainNavDesktop : connectedCallback");
        try {
            this.config = (_a = window.UTK_themeConfig) === null || _a === void 0 ? void 0 : _a.mainNavigationDesktop;
            if ((_b = window.UTK_themeConfig) === null || _b === void 0 ? void 0 : _b.mainNavigationPersonalizationDesktop) {
                const selectorName = (_c = window.UTK_themeConfig) === null || _c === void 0 ? void 0 : _c.mainNavigationPersonalizationDesktop.apiSelectorName;
                const personalizationResults = await getPersonalizationCampaigns({ apiSelectorNames: [selectorName] });
                const decision = personalizationResults.choices.find((c) => c.name.toLowerCase() === selectorName.toLowerCase());
                if (decision === null || decision === void 0 ? void 0 : decision.variations) {
                    const payloadData = decision.variations[0].payload.data;
                    if (payloadData) {
                        const id = payloadData.id;
                        const variation = (_d = window.UTK_themeConfig) === null || _d === void 0 ? void 0 : _d.mainNavigationPersonalizationDesktop.variations.find((v) => v.variationId.toLowerCase() === id.toLowerCase());
                        if (variation) {
                            const behavior = variation.variationBehavior;
                            if (behavior === "replace") {
                                console.log("MainNavDesktop: replacing desktop nav config", variation.replacement);
                                this.config = variation.replacement;
                            }
                        }
                    }
                    else {
                        console.log("user served control");
                    }
                }
            }
        }
        catch (e) {
            console.error("Error parsing config", e);
        }
        finally {
            console.log("MainNavDesktop : rendered config", this.config);
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            let appendToEl = this;
            const appendToSelector = this.getAttribute("append-to-selector");
            if (appendToSelector) {
                appendToEl = document.querySelector(appendToSelector);
            }
            this.render(appendToEl);
        }
    }
    handleNavChange(e) {
        var _a;
        const target = e.target;
        const menuLinkOuterEl = target.classList.contains('menu-link-outer') ? target : target.closest('.menu-link-outer');
        if (menuLinkOuterEl) {
            const key = menuLinkOuterEl.getAttribute('data-key');
            const section = (_a = this.config) === null || _a === void 0 ? void 0 : _a.sections.find(section => handleize(section.title) === key);
            this.populateCategoryEl(section === null || section === void 0 ? void 0 : section.categories, section === null || section === void 0 ? void 0 : section.title);
        }
    }
    render(appendCategoriesTo) {
        var _a, _b, _c, _d, _e, _f;
        if (!this.config) {
            console.error(`MainNavDesktop: No config found. Sanity config: ${window.UTK_themeConfig ? 'found' : 'missing'}. Main nav config: ${((_a = window.UTK_themeConfig) === null || _a === void 0 ? void 0 : _a.mainNavigationDesktop) ? 'found' : 'missing'}.`);
        }
        else if (!((_b = this.config) === null || _b === void 0 ? void 0 : _b.sections) || ((_c = this.config) === null || _c === void 0 ? void 0 : _c.sections.length) === 0) {
            console.error(`MainNavDesktop: No sections found in config.`, this.config);
        }
        const initSection = (((_d = this.config) === null || _d === void 0 ? void 0 : _d.sections) || []).find(section => {
            const found = (section.categories || []).find(s => location.href.includes(s.url));
            if (found) {
                return section;
            }
        }) || ((_e = this.config) === null || _e === void 0 ? void 0 : _e.sections[0]);
        this.innerHTML = `
      <ul class="header__desktop-menu-list">
        ${(_f = this.config) === null || _f === void 0 ? void 0 : _f.sections.map(section => {
            const handle = handleize(section.title);
            return `
            <li id="nav_${handle}" class="menu-link-outer" data-key="${handle}">
              <a class="menu-link-top" href="${section.url || "#"}" style="${section.color ? `color: ${section.color.value};text-decoration-color: ${section.color.value}` : ''}" data-qm-menu-click="${section.title.toLowerCase().replace(/\s/g, "")}">
                <span>${section.title}</span>
              </a>
            </li>
          `;
        }).join('')}
        ${this.getNobiButton() || ''}
      </ul>
    `;
        // render subnav
        const subnavElContainer = document.createElement('div');
        subnavElContainer.classList.add('header__desktop-menu-list-sub-nav-container');
        this.categoryEl = subnavElContainer;
        appendCategoriesTo.append(subnavElContainer);
        this.populateCategoryEl(initSection === null || initSection === void 0 ? void 0 : initSection.categories, initSection === null || initSection === void 0 ? void 0 : initSection.title);
    }
    populateCategoryEl(categories, sectionTitle) {
        if (this.categoryEl) {
            if ((categories === null || categories === void 0 ? void 0 : categories.length) > 0) {
                this.categoryEl.classList.remove('hidden');
                this.categoryEl.innerHTML = `
        <ul class="header__desktop-menu-list-sub-nav" id="main-nav-desktop-subnav_${handleize(sectionTitle)}">
          ${categories.map(category => {
                    return `
              <li>
                <a id="main-nav-desktop-subnav-link_${handleize(sectionTitle)}_${handleize(category.title)}" class="header__desktop-menu-list-sub-nav-link" style="${category.color ? `color: ${category.color.value};` : ''}"  href="${category.url}" data-qm-menu-click="${sectionTitle === null || sectionTitle === void 0 ? void 0 : sectionTitle.toLowerCase().replace(/\s/g, "")}|${category.title.toLowerCase().replace(/\s/g, "")}">${category.title}</a>
              </li>
            `;
                }).join('')}
        </ul>
      `;
            }
            else {
                this.categoryEl.classList.add('hidden');
                this.categoryEl.innerHTML = "";
            }
        }
    }
    getNobiButton() {
        var _a;
        const nobiButtonTemplate = document.getElementById('nobi-button-template');
        if (!nobiButtonTemplate) {
            return null;
        }
        const fragment = nobiButtonTemplate.content.cloneNode(true);
        return `<li id="nav_search" class="menu-link-outer" data-key="search">${(_a = fragment.firstElementChild) === null || _a === void 0 ? void 0 : _a.outerHTML}</li>`;
    }
}
if (!window.customElements.get("main-nav-desktop")) {
    customElements.define("main-nav-desktop", MainNavDesktop);
}
